import styled from "styled-components";

export const ColumnsWrapper = styled.div`
  width: 100%;
  padding: 20px;

  display: flex;
  column-gap: 5px;
  
  text-align: left;

  color: black;
  font-weight: 600;
  background: #fafafa;
  border-bottom: 1px solid rgba(0,0,0,.06);
`

export const Column = styled.div`
`
